<div class="contact-details-container">
    <div class="details-header">
        <!-- <h2>My Views</h2> -->
    </div>



    <div class="details-content">

        <!-- Basic View -->
        <div>
            <div class="content-section">
                <table *ngIf="leadCommonPropertiesDisplay==1
                    && filteredUsedInSite!=null&&(filteredUsedInSite
                     | keyvalue)?.length> 0">
                    <tr>
                        <th colspan="2">{{ leadCommonPropertiesName }}</th>
                    </tr>

                    <!-- If not type3 -->
                    <ng-container>

                        <tr *ngFor="let item of 
                        filteredUsedInSite | keyvalue">
                            <td>{{ item.key }}</td>
                            <td>
                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source'"
                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                    class="blackColor wordBreak" [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                    class="blackColor wordBreak" [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                            </td>
                        </tr>
                    </ng-container>


                </table>

                <table *ngIf="leadPropertiesDisplay==1 && filteredValuesList!=null&&(filteredValuesList
                     | keyvalue)?.length> 0">
                    <tr>
                        <th colspan="2">{{ leadPropertiesName }}</th>
                    </tr>

                    <!-- If not type3 -->
                    <ng-container>

                        <tr *ngFor="let item of 
                        filteredValuesList  | keyvalue">
                            <td>{{ item.key }}</td>
                            <td>
                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source'"
                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                    class="blackColor wordBreak" [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                    class="blackColor wordBreak" [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                            </td>
                        </tr>
                    </ng-container>


                </table>


                <table *ngIf="leadAdditionalPropertiesDisplay==1
                    && filteredAdditionalSpec!=null&&(filteredAdditionalSpec
                     | keyvalue)?.length> 0">
                    <tr>
                        <th colspan="2">{{ leadAdditionalPropertiesName }}</th>
                    </tr>

                    <!-- If not type3 -->
                    <ng-container>

                        <tr *ngFor="let item of 
                        filteredAdditionalSpec  | keyvalue">
                            <td>{{ item.key }}</td>
                            <td>
                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source'"
                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                    class="blackColor wordBreak" [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                    class="blackColor wordBreak" [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                            </td>
                        </tr>
                    </ng-container>



                </table>


                <table>
                    <tr>
                        <th colspan="2">Original Lead Format</th>
                    </tr>

                    <!-- If not type3 -->
                    <ng-container  *ngIf="originalSpec && (originalSpec | keyvalue).length > 0;">

                        <tr *ngFor="let item of 
                        originalSpec  | keyvalue">
                           
                            <td>
                                {{ item.key === 'adGroupName' ? 'Campaign Name' : item.key
                                }}
                            </td>
                            <td>
                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source'"
                                    class="blackColor wordBreak" [innerHTML]="item.value">
                                </p>

                                <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                            </td>
                        </tr>
                    </ng-container>



                    </table>



                    <!-- Global empty-state: show when all visible filtered sections are empty -->
                    <div *ngIf="((leadCommonPropertiesDisplay==1 ? (filteredUsedInSite | keyvalue)?.length : 0) + (leadPropertiesDisplay==1 ? (filteredValuesList | keyvalue)?.length : 0) + (leadAdditionalPropertiesDisplay==1 ? (filteredAdditionalSpec | keyvalue)?.length : 0)) == 0"
                        class="no-records-global">
                        <table>
                            <tr>
                                <th colspan="2">No Records Found</th>
                            </tr>
                        </table>
                    </div>

            </div>
        </div>
    </div>

</div>